var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.3333 0.666016H1.66668C0.933344 0.666016 0.34001 1.26602 0.34001 1.99935L0.333344 9.99935C0.333344 10.7327 0.933344 11.3327 1.66668 11.3327H12.3333C13.0667 11.3327 13.6667 10.7327 13.6667 9.99935V1.99935C13.6667 1.26602 13.0667 0.666016 12.3333 0.666016ZM12.3333 3.33268L7.00001 6.66602L1.66668 3.33268V1.99935L7.00001 5.33268L12.3333 1.99935V3.33268Z","fill":"black","fillOpacity":"0.87"}));
}

Email.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none"};

module.exports = Email;

Email.default = Email;
